import { StatusChip, StatusChipColor } from "components/StatusChip";
import { WasteShipmentStatus } from "generated-graphql/graphql";

import { SHIPMENT_STATUS_LABELS } from "./shipmentDisplay";

const STATUS_COLORS: Record<WasteShipmentStatus, StatusChipColor> = {
  [WasteShipmentStatus.Draft]: "default",
  [WasteShipmentStatus.Requested]: "info",
  [WasteShipmentStatus.Shipped]: "success",
  [WasteShipmentStatus.Canceled]: "default",
};

/**
 * The shipment's status, as the light-filled chip the design system specs.
 *
 * `soft` rather than `outlined`: both are Ready for dev, and the shipment
 * frames use the filled one. Applied everywhere this chip appears, since a
 * status that looked one way on the detail page and another in the list would
 * read as two facts rather than one.
 */
export function WasteShipmentStatusChip({ status }: { status: WasteShipmentStatus }) {
  return (
    <StatusChip
      label={SHIPMENT_STATUS_LABELS[status]}
      color={STATUS_COLORS[status]}
      variant="soft"
    />
  );
}
